import { render, staticRenderFns } from "./dailyAssetAdd.vue?vue&type=template&id=2a40e05a&scoped=true&"
import script from "./dailyAssetAdd.vue?vue&type=script&lang=js&"
export * from "./dailyAssetAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a40e05a",
  null
  
)

export default component.exports